import React from 'react'
import Livescore from '../components/ls/Livescore'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Link} from "react-router-dom";

class Tomorrow extends React.Component{

    constructor(props){
        super(props)
        this.state = {
           date : null
        }
     }

     componentDidMount(){
        this.setState({date : new Date(Date.now() + (3600000*7) + (3600000*24)).toISOString().slice(0,10)})
     }
     
    render() {
        return (
            this.state.date!==null?
         <HelmetProvider>
            <Helmet>
            <title>บอลพรุ่งนี้ ตารางบอลล่วงหน้า โปรแกรมบอลพรุ่งนี้ บ้านบอล ราคาบอลพรุ่งนี้</title>
            <meta name="description" content="โปรแกรมบอลพรุ่งนี้ ตารางบอลพรุ่งนี้พร้อมราคา เช็คโปรแกรมพรีเมียร์ลีก บ้านบอลวันถัดไป คู่ไหนลงสนามแข่ง มีแมตซ์ไหนน่าสนใจ มาเช็คผ่านตารางบอลพรุ่งนี้ของเว็บไซต์ MVPKICK.COM" />
            <link rel="canonical" href='https://mvpkick.com/บอลพรุ่งนี้/' />
            <meta property="og:url" content="https://mvpkick.com/บอลพรุ่งนี้/" />
            <meta property="og:title" content="บอลพรุ่งนี้ ตารางบอลล่วงหน้า โปรแกรมบอลพรุ่งนี้ บ้านบอล ราคาบอลพรุ่งนี้" />
            <meta property="og:description" content="โปรแกรมบอลพรุ่งนี้ ตารางบอลพรุ่งนี้พร้อมราคา เช็คโปรแกรมพรีเมียร์ลีก บ้านบอลวันถัดไป คู่ไหนลงสนามแข่ง มีแมตซ์ไหนน่าสนใจ มาเช็คผ่านตารางบอลพรุ่งนี้ของเว็บไซต์ MVPKICK.COM" />
            <meta property="og:image" content="https://mvpkick.com/img/asset/og-img-main.jpg" />
            </Helmet>
           <div>
               <Livescore selectDate={this.state.date} />
               <div className="boxContentPage">
               <div>
                    <h1>ตารางบอลพรุ่งนี้ โปรแกรมบอลพรุ่งนี้ ผลบอลพรุ่งนี้พร้อมราคาบอล</h1>
                    <p>ในวันพรุ่งนี้มีรายการทัวร์นาเม้นไหนลงสนามกันบ้าง อยากรู้ก่อนใครต้องเกาะติดที่นี่ สามารถดูโปรแกรมบอลล่วงหน้าได้ถึง 2 วัน แสดงแยกตามทัวร์นาเม้นให้หาข้อมูลง่ายยิ่งขึ้น เวลาลงแข่งอิงตามเวลาประเทศไทย ข้อมูลถูกต้องชัวร์ชัดเจน หากมีรายการไหนเลื่อนเวลาลงสนาม ทางตารางบอลพรุ่งนี้บนเว็บ MVPKICK จะทำการอัพเดทเวลาลงแข่งเช่นกัน ทำให้ไม่ต้องกลัวพลาด เช็คข้อมูลชัวร์สุด ครบถ้วนทุกแมตซ์ ดูฟรีไม่ต้องโหลดแอพให้ยุ่งยาก เพียงเข้า MVPKICK.COM เลือกมาที่หน้า <Link to="/บอลพรุ่งนี้/">บอลพรุ่งนี้</Link> ก็รู้ถึงตารางโปรแกรมแข่งขันที่เตรียมจะเกิดขึ้นในวันพรุ่งนี้ได้ทันที บอลลีกใหญ่ บอลรอง บอล อบต. ฟุตบอลโลก แมตซ์กระชับมิตรสโมสร จะยอดฮิตหรือคนสนใจน้อยก็มีให้เลือกเช็คโปรแกรมบอลทุกคู่ พร้อมเมนู H2H เพื่อนเช็คประวัติการพบกันในอดีตที่ผ่านของแต่ละรายการแข่ง หากมีราคาบอลเปิดในตลาดแล้ว จะมีข้อมูลราคาต่อรองแสดงในหน้า H2H เช่นกัน รู้ทั้งสถิติย้อนหลังและราคาต่อรองในแต่ละคู่ได้ในหน้าเดียว</p>
                    <p>ในรายการแข่งสุดสัปดาห์เสาร์อาทิตย์ มักจะมีโปรแกรมบอลพรุ่งนี้แสดงอยู่หลายร้อยคู่ ทางเว็บไซต์ของเราออกแบบให้ผู้ใช้สามารถเลือกแสดงผลเฉพาะกลุ่มลีกยอดนิยมเพียงอย่างเดียว หรือเลือกแสดงทั้งหมดก็ได้เช่นกัน เพื่อให้ง่ายในการหาคู่แข่งขันที่ผู้ใช้กำลังสนใจ รวมถึงสามารถย่อหน้าจอบางลีกไม่ให้แสดงข้อมูลก็ได้เช่นกัน ออกแบบตารางบอลให้ผู้ใช้สามารถเลือกปรับแสดงผลได้ตามสะดวก ใช้งานง่าย ดูสบายตา และมาพร้อมทุกข้อมูลสถิติสำคัญ เมื่อรู้ถึงเวลาลงสนามของทีมโปรดในดวงใจ อย่าลืมมาร่วมเชียร์บอลสดๆระหว่างแข่งได้จากหน้าแรกของเว็บไซต์เรา <Link to="/">ผลบอลสด</Link> สกอร์อัพเดทตลอดเวลา เฮลั่นทันเพื่อน ข้อมูลสกอร์บอลที่เกิดขึ้นแม่นยำ ถูกต้อง ไม่มีเผลอร้องเฮเก้อแน่นอน มองหาเว็บผลบอลสดที่ทันสมัย เข้ากับมือถือยุคใหม่ ใช้งานง่าย โหลดไว ไม่กระตุก และมีรายการแข่งเยอะครอบคลุมเกือบทุกแมตซ์จากทั่วโลก ถูกรวมไว้หน้าจอเดียวส่งตรงสู่สมาร์ทโฟนของคุณ MVPKICK เว็บฟุตบอลที่คุณต้องชอบ</p>
               </div>
               </div>
           </div>
         </HelmetProvider>:
         <div>No Data</div>
        )
     }
}

export default Tomorrow;